/** Stable wire format: voice stays a text message for compatibility with existing databases. */
export const voiceCardPrefix = 'shixu-voice-card-v1:'
export const MAX_VOICE_DURATION_MS = 60_000
export const MIN_VOICE_DURATION_MS = 300
export const MAX_VOICE_BYTES = 5 * 1024 * 1024

export interface VoiceCard {
  uploadId: string
  durationMs: number
  mime: string
  size: number
}

export function encodeVoiceCard(card: VoiceCard) {
  return `${voiceCardPrefix}${JSON.stringify(card)}`
}

export function decodeVoiceCard(body: string): VoiceCard | null {
  if (!body.startsWith(voiceCardPrefix)) return null
  try {
    const value: unknown = JSON.parse(body.slice(voiceCardPrefix.length))
    if (!value || typeof value !== 'object') return null
    const card = value as Partial<VoiceCard>
    if (typeof card.uploadId !== 'string' || !/^[a-zA-Z0-9-]{1,80}$/.test(card.uploadId)) return null
    if (typeof card.durationMs !== 'number' || !Number.isFinite(card.durationMs) || card.durationMs < MIN_VOICE_DURATION_MS || card.durationMs > MAX_VOICE_DURATION_MS) return null
    if (card.mime !== 'audio/mp4' || typeof card.size !== 'number' || !Number.isInteger(card.size) || card.size < 1 || card.size > MAX_VOICE_BYTES) return null
    return { uploadId: card.uploadId, durationMs: card.durationMs, mime: card.mime, size: card.size }
  } catch {
    return null
  }
}

export function voiceCardText(card: VoiceCard) {
  return `[语音] ${Math.ceil(card.durationMs / 1000)}秒`
}
